import React from 'react';

import TextField from './TextField';


/**
 * Date input — native `<input type="date">` rendered via TextField. The
 * trailing calendar button + native picker opening live in the shared `Input`
 * primitive (so form fields and inline filter date inputs behave identically);
 * the duplicate native indicator is hidden in global.css. corelib is exempt
 * from the T17 native-`<input type=date>` ban.
 */
const DateField = React.forwardRef((props, ref) => (
  <TextField ref={ref} type="date" {...props} />
));

DateField.displayName = 'DateField';
export default DateField;
